import { Box, Button } from '@chakra-ui/react';
import { PricingInterval } from 'types/subscription.types';

type SupportedValues = string;

export interface GroupOption {
  label: string;
  value: PricingInterval;
}

export interface RadioButtonGroupProps {
  options: GroupOption[];
  value?: SupportedValues;
  onChange: (value: PricingInterval) => void;
}

export const RadioButtonGroup = ({
  options,
  onChange,
  value,
}: RadioButtonGroupProps) => {
  return (
    <Box display="inline-flex">
      {options.map((option: GroupOption, i) => {
        return (
          <Button
            variant={value === option.value ? 'primary' : 'secondary'}
            size="sm"
            key={option.value}
            ml={i > 0 ? 3 : 0}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
};
